
/* The Appliance Barn — Brands menu interaction */
(() => {
  if (window.__abBrandsMenuInit) return;
  window.__abBrandsMenuInit = true;

  function activate(root, index) {
    if (!root) return;

    root.querySelectorAll('[data-ab-brand-option]').forEach(el => {
      const active = el.dataset.brandIndex === index;
      el.classList.toggle('is-active', active);

      if (active) {
        el.setAttribute('aria-current', 'true');
      } else {
        el.removeAttribute('aria-current');
      }
    });

    root.querySelectorAll('[data-ab-brand-categories]').forEach(el => {
      const active = el.dataset.abBrandCategories === index;
      el.classList.toggle('is-active', active);
      el.hidden = !active;
    });

    root.querySelectorAll('[data-ab-brand-visual]').forEach(el => {
      const active = el.dataset.abBrandVisual === index;
      el.classList.toggle('is-active', active);
      el.hidden = !active;
    });
  }

  document.addEventListener('pointerover', e => {
    const option = e.target.closest?.('[data-ab-brand-option]');

    if (option && e.pointerType !== 'touch') {
      activate(
        option.closest('[data-ab-brands]'),
        option.dataset.brandIndex
      );
    }
  });

  document.addEventListener('focusin', e => {
    const option = e.target.closest?.('[data-ab-brand-option]');

    if (option) {
      activate(
        option.closest('[data-ab-brands]'),
        option.dataset.brandIndex
      );
    }
  });

  document.addEventListener('click', e => {
    const option = e.target.closest?.('[data-ab-brand-option]');
    if (!option) return;

    if (window.matchMedia('(max-width: 989px)').matches) {
      return;
    }

    // Clicking a brand navigates to its collection.
    // Hovering or focusing previews its categories.
  });
})();
